// extracted by mini-css-extract-plugin
export var alignCenter = "_7d-d";
export var bannerShown = "_7d-6";
export var buttonContent = "_7d-0";
export var cardList = "_7d-1";
export var centerContent = "_7d-2";
export var chevron = "_7d-3";
export var closePanelButton = "_7d-k";
export var conversationContextContainer = "_7d-l";
export var conversationDetailContainer = "_7d-4";
export var detailWrapper = "_7d-7";
export var dropdownButton = "_7d-e";
export var dropdownTitle = "_7d-9";
export var fullHeight = "_7d-5";
export var hidden = "_7d-a";
export var icon = "_7d-b";
export var mergeSuggestionWrapper = "_7d-m";
export var panel = "_7d-i";
export var portalButtonsWrapper = "_7d-c";
export var right = "_7d-j";
export var tableSummaryContainer = "_7d-8";
export var tableSummaryHeader = "_7d-g";
export var threeDotsButton = "_7d-f";
export var wide = "_7d-h";